export const SET_ACCOUNT = 'SET_ACCOUNT'

export const setAccount = data => async dispatch => {
  dispatch({
    type: SET_ACCOUNT,
    payload: data
  })
}